export default __webpack_public_path__ + "static/mozilla-2d2d47fbc1770ecc83b357b9ae72607a.svg";